module.exports = __webpack_public_path__ + "static/media/pow.1402638f.png";